"use client"


import {MenuBuilderShortcutModel} from "@/core/model/main.model";
import useLocalStorage from "@/core/utils/localStorage";
import {LOGIN_STATE_KEY} from "@/core/services/CONSTANTS";
import {useDispatch} from "react-redux";
import {AppDispatch} from "@/core/redux/store";
import {loginState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE} from "@/core/reducer/CONSTANTS";
import {shortcutState} from "@/core/reducer/shortcutReducer";
import {BRT_MAP, MENU_BUILDER, SUBWAY_MAP} from "@/core/navigation/CONSTANTS";
import {useTranslations} from "use-intl";
import {useRouter} from "next/navigation";
import queryString from 'query-string';
import {HTTP_KEY, MAIN_APP_URL} from "@/core/CONSTANTS";

interface Props{
    shortcut:MenuBuilderShortcutModel
}

export default function ToolsShortcutComponent(props:Props){
    const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
    const dispatch = useDispatch<AppDispatch>();
    const t = useTranslations();
    const router=useRouter();
    function saveShortcutClickState(dispatch: AppDispatch, shortcut: MenuBuilderShortcutModel) {
        //TODO fix
        // switch (shortcut.unique_name) {
        //     case BRT_MAP.replace('/t/', ''):
        //     case SUBWAY_MAP.replace('/t/', ''):
        //         break;
        // }
        // shortcut.isDelete = shortcut?.isDelete ?? false;
        let hasSetting = false;
        switch (shortcut.unique_name) {
            case BRT_MAP.replace('/t/', ''):
            case SUBWAY_MAP.replace('/t/', ''):
                hasSetting = true;
                break;
        }
        // shortcut.isDelete = shortcut?.isDelete ?? false;
        dispatch(shortcutState({item: shortcut, hasSetting: hasSetting}));
    }
    function removeShortcutClickState(dispatch: AppDispatch) {
        dispatch(shortcutState({item:null,hasSetting:false}));
    }
    function clickShortcutItem(shortcut:MenuBuilderShortcutModel) {
        if (shortcut?.is_enabled ?? true) {
            if ((shortcut.login_required ?? false) && !isLogin) {
                dispatch(loginState({state: LOGIN_STATE, openLoginPage:true}));
            } else {
                const title = shortcut.title?.fa??t(`shName.${shortcut.unique_name}`);
                if (shortcut.url?.includes('tlbx://dynamicPage')) {
                    removeShortcutClickState(dispatch);
                    const qp = queryString.parseUrl(shortcut.url).query;
                    if (qp && qp.group) {
                        const group = qp.group.toString();
                        const title = qp.title?.toString() ?? '';
                        router.push(MENU_BUILDER.replace(':page', group)+`?shTitle=${title}`);
                    }
                } else if (shortcut.url?.includes('tlbx://generalWebView')) {
                    saveShortcutClickState(dispatch, shortcut);
                    const qp = queryString.parseUrl(shortcut.url).query;
                    if (qp && qp.url) {
                        const path = qp.url.toString();
                        if ((path.includes('tlbx.ir') || path.includes('tlbxapp.com'))&&(!path.includes('game.tlbx.ir')) && shortcut.unique_name) {
                            const path: string = `/t/${shortcut.unique_name}`;
                            router.push(path+`?shTitle=${title}`);
                        } else {
                            router.push('/t/generalWeb'+`?shTitle=${title}&title=${title}&url=${path}`);
                        }
                    }
                } else if (shortcut.url?.includes(HTTP_KEY)) {
                    const qp = queryString.parseUrl(shortcut.url).query;
                    if (qp && qp.url) {
                        if (qp.url.toString().includes(MAIN_APP_URL)) {
                            saveShortcutClickState(dispatch, shortcut);
                            const path = qp.url.toString().split(MAIN_APP_URL)[1];
                            router.push(path+`?shTitle=${title}`);
                        } else {
                            if (typeof window !== 'undefined') window.open(qp.url.toString(), '_self');
                        }
                    } else {
                        if (typeof window !== 'undefined') window.open(shortcut.url.toString(), '_self');
                    }
                } else {
                    saveShortcutClickState(dispatch, shortcut);
                    const path: string = `/t/${shortcut.unique_name}`;
                    if (shortcut.url?.includes('tlbx://media')) {
                        // if (path.includes('video_gardi')) {
                        //     path = VIDEO_GARDI_PATH;
                        // } else if (path.includes('movie')) {
                        //     path = FILM_SERIAL_PATH;
                        // }
                        router.push(path+`${shortcut.url?.split('tlbx://media')[1]}&shTitle=${title}`);
                    } else {
                        router.push(path+`?shTitle=${title}`);
                    }
                }
            }
        }
    }

    return(
        <div className={"w-full h-full absolute"} onClick={()=>clickShortcutItem(props.shortcut)} />
    )
}